import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/layout';

import MapLogo from '../img/map.png';

function Contact({data}) {
	return (
		<Layout>
			<div className="contact">
				<div className="contact__info">
					<span className="contact__label">Contact Us:</span>
					<a href={'tel:'+data.site.siteMetadata.phone}>{data.site.siteMetadata.phone}</a>
					<span>{'Fax: '+data.site.siteMetadata.fax}</span>
					<a href={'mailto:'+data.site.siteMetadata.email}>Email: {data.site.siteMetadata.email}</a>
					<span className="contact__label">Address:</span>
					<span>{data.site.siteMetadata.addressLine1}</span>
					<span>{data.site.siteMetadata.addressLine2}</span>
					<span>{data.site.siteMetadata.addressLine3}</span>

					<span className="contact__label">Hours:</span>
					<span>4AM - 2PM Monday - Friday</span>
					<span>Closed Saturday - Sunday</span>

					<span className="contact__label">Directions:</span>
					<a className="contact__dir-link" href="https://www.google.com/maps/dir/?api=1&destination=Pork+King+Sausage+Co&destination_place_id=ChIJQfOPpxD1wokRAq1AfdBJVlE"><img className="contact__dir-img" src={MapLogo} alt="click for directions" /></a>
				</div>
				<iframe title="Pork King Map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3019.8218617616876!2d-73.87470798464369!3d40.80990817932139!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2f510a78ff341%3A0x515649d07d40ad02!2sPork+King+Sausage+Co!5e0!3m2!1sen!2sus!4v1539375899829" allowFullScreen></iframe>
			</div>
		</Layout>
	);
}

export default Contact;

export const query = graphql`
	query {
		site {
			siteMetadata {
				phone
				fax
				email
				addressLine1
				addressLine2
				addressLine3
			}
		}
	}
`